function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("title", null, "view-letter");

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19.25,
    height: 18.81,
    viewBox: "0 0 19.25 18.81"
  }, props), _ref, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.34,16l6.07-6.07A5.56,5.56,0,1,0,9.05,8.44L2.36,14.06ZM14,1.2a4.33,4.33,0,1,1-4.63,4A4.34,4.34,0,0,1,14,1.2Z",
    style: {
      "fill": "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.34,12.34c-.13,0-.26,0-.38,0v4.35a1.11,1.11,0,0,1-1.11,1.1H2.12A1.1,1.1,0,0,1,1,16.69V4.24a1.1,1.1,0,0,1,1.1-1.1h5.3a5.82,5.82,0,0,1,.63-1H2.12A2.12,2.12,0,0,0,0,4.24V16.69a2.12,2.12,0,0,0,2.12,2.12h9.73A2.13,2.13,0,0,0,14,16.69V12.34A4.56,4.56,0,0,1,13.34,12.34Z",
    style: {
      "fill": "#fff"
    }
  })));
};

export default __webpack_public_path__ + "static/media/view-letter.bbecadfd.svg";
export { SvgComponent as ReactComponent };